import { default as aboutcggDDldG7iMeta } from "/vercel/path0/pages/about.vue?macro=true";
import { default as afterPurchaseD4Z08CGx9aMeta } from "/vercel/path0/pages/afterPurchase.vue?macro=true";
import { default as appcIKN7O1TY8Meta } from "/vercel/path0/pages/app.vue?macro=true";
import { default as authConfirm4GrJVOY8HeMeta } from "/vercel/path0/pages/authConfirm.vue?macro=true";
import { default as authenticatingDesktopd2rpREoD6WMeta } from "/vercel/path0/pages/authenticatingDesktop.vue?macro=true";
import { default as authenticatingWebwk1qs8G3xiMeta } from "/vercel/path0/pages/authenticatingWeb.vue?macro=true";
import { default as authGoogleMobileY31FHkLnjlMeta } from "/vercel/path0/pages/authGoogleMobile.vue?macro=true";
import { default as confirmEmailLFmouLTY7wMeta } from "/vercel/path0/pages/confirmEmail.vue?macro=true";
import { default as featuresenv3YeqUT9Meta } from "/vercel/path0/pages/features.vue?macro=true";
import { default as forgotPassword17GKghrUVfMeta } from "/vercel/path0/pages/forgotPassword.vue?macro=true";
import { default as fromDesktopMbHzf7PqFWMeta } from "/vercel/path0/pages/fromDesktop.vue?macro=true";
import { default as howGQ9IJ4kGjfMeta } from "/vercel/path0/pages/how.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as log_signBOtASSzQq1Meta } from "/vercel/path0/pages/log_sign.vue?macro=true";
import { default as pricingIYNdvfoSO6Meta } from "/vercel/path0/pages/pricing.vue?macro=true";
import { default as privacykJ3SQnmrN4Meta } from "/vercel/path0/pages/privacy.vue?macro=true";
import { default as admin4V5NkhJjTHMeta } from "/vercel/path0/pages/sofnorufnpiauninrferfneirfnerf/admin.vue?macro=true";
import { default as termsq5qlZHSSonMeta } from "/vercel/path0/pages/terms.vue?macro=true";
import { default as checkingxf2GIkWPn4Meta } from "/vercel/path0/pages/user/checking.vue?macro=true";
import { default as profileGl5mqoo5nGMeta } from "/vercel/path0/pages/user/profile.vue?macro=true";
import { default as tasksoRFLigJWn5Meta } from "/vercel/path0/pages/user/tasks.vue?macro=true";
import { default as tasks2wF0xC9Hd3bMeta } from "/vercel/path0/pages/user/tasks2.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/vercel/path0/pages/about.vue").then(m => m.default || m)
  },
  {
    name: "afterPurchase",
    path: "/afterPurchase",
    component: () => import("/vercel/path0/pages/afterPurchase.vue").then(m => m.default || m)
  },
  {
    name: "app",
    path: "/app",
    component: () => import("/vercel/path0/pages/app.vue").then(m => m.default || m)
  },
  {
    name: "authConfirm",
    path: "/authConfirm",
    component: () => import("/vercel/path0/pages/authConfirm.vue").then(m => m.default || m)
  },
  {
    name: "authenticatingDesktop",
    path: "/authenticatingDesktop",
    meta: authenticatingDesktopd2rpREoD6WMeta || {},
    component: () => import("/vercel/path0/pages/authenticatingDesktop.vue").then(m => m.default || m)
  },
  {
    name: "authenticatingWeb",
    path: "/authenticatingWeb",
    meta: authenticatingWebwk1qs8G3xiMeta || {},
    component: () => import("/vercel/path0/pages/authenticatingWeb.vue").then(m => m.default || m)
  },
  {
    name: "authGoogleMobile",
    path: "/authGoogleMobile",
    meta: authGoogleMobileY31FHkLnjlMeta || {},
    component: () => import("/vercel/path0/pages/authGoogleMobile.vue").then(m => m.default || m)
  },
  {
    name: "confirmEmail",
    path: "/confirmEmail",
    component: () => import("/vercel/path0/pages/confirmEmail.vue").then(m => m.default || m)
  },
  {
    name: "features",
    path: "/features",
    component: () => import("/vercel/path0/pages/features.vue").then(m => m.default || m)
  },
  {
    name: "forgotPassword",
    path: "/forgotPassword",
    component: () => import("/vercel/path0/pages/forgotPassword.vue").then(m => m.default || m)
  },
  {
    name: "fromDesktop",
    path: "/fromDesktop",
    meta: fromDesktopMbHzf7PqFWMeta || {},
    component: () => import("/vercel/path0/pages/fromDesktop.vue").then(m => m.default || m)
  },
  {
    name: "how",
    path: "/how",
    component: () => import("/vercel/path0/pages/how.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "log_sign",
    path: "/log_sign",
    meta: log_signBOtASSzQq1Meta || {},
    component: () => import("/vercel/path0/pages/log_sign.vue").then(m => m.default || m)
  },
  {
    name: "pricing",
    path: "/pricing",
    component: () => import("/vercel/path0/pages/pricing.vue").then(m => m.default || m)
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/vercel/path0/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: "sofnorufnpiauninrferfneirfnerf-admin",
    path: "/sofnorufnpiauninrferfneirfnerf/admin",
    meta: admin4V5NkhJjTHMeta || {},
    component: () => import("/vercel/path0/pages/sofnorufnpiauninrferfneirfnerf/admin.vue").then(m => m.default || m)
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/vercel/path0/pages/terms.vue").then(m => m.default || m)
  },
  {
    name: "user-checking",
    path: "/user/checking",
    meta: checkingxf2GIkWPn4Meta || {},
    component: () => import("/vercel/path0/pages/user/checking.vue").then(m => m.default || m)
  },
  {
    name: "user-profile",
    path: "/user/profile",
    component: () => import("/vercel/path0/pages/user/profile.vue").then(m => m.default || m)
  },
  {
    name: "user-tasks",
    path: "/user/tasks",
    meta: tasksoRFLigJWn5Meta || {},
    component: () => import("/vercel/path0/pages/user/tasks.vue").then(m => m.default || m)
  },
  {
    name: "user-tasks2",
    path: "/user/tasks2",
    meta: tasks2wF0xC9Hd3bMeta || {},
    component: () => import("/vercel/path0/pages/user/tasks2.vue").then(m => m.default || m)
  }
]